import $ from 'jquery';

import BasePropertyView from 'BasePropertyView.js'
import contentTemplate from 'properties/style/background-color.ejs';
import _color2Template from 'properties/style/background-color2.ejs';
import util from 'util/Util.js';
import imageUtil from 'util/ImageUtil.js';
import { pickerCfg } from 'pickerCfg.js';
import pageSyncService from 'PageSyncService.js';
import constants from 'Constants.js';
import textConstants from 'TextConstants.js';
import undoService from 'UndoService';
import themeService from 'ThemeService.js';
import eventBus from 'EventBus.js';
import mobileSyncService from "../../../service/mobile/MobileSyncService";

class StyleBackgroundColorView extends BasePropertyView {

    initialize(opts) {
        super.initialize(opts);

        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        // !! Use Specific ids for hooking events when possible !!
        this.events = {
            'blur input[type=text]': 'lostFocus',
            'focus input[type=text]': 'getFocus',
            'change input[type=text]': 'updateColorAttributesWithValidation',
            'change input[type=color]': 'updateColorAttributes',
            'change input[type=checkbox]': 'updateCheckboxAttributes',
            'change input[name="transparentBackground"]': 'updateTransparentBackground'
        };

        if (this.model.get('factoryKey') === 'control_checkbox' ||
            this.model.get('factoryKey') === 'control_radio_button' ||
            this.model.get('factoryKey') === 'control_mask_text_input' ||
            this.model.get('factoryKey') === 'control_file_attachment' ||
            this.model.get('factoryKey') === 'control_image_input') {
            this.template = _color2Template;
        }

        return this;
    }

    updateColorAttributesWithValidation(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        let oldValue = this.model.get(propName);

        undoService.add({
            undo: () =>{
                if (util.isValidColorcode(oldValue)) {
                    let color = this.resolveColor(oldValue);
                    this.model.set(propName, color);
                }
                this.render();
                if (this.model.get('factoryKey') === "page_instance"
                || this.model.get('factoryKey') === "layout_page"
                || this.model.get('factoryKey') === "report_page") {
                pageSyncService.renderCurrentPageView();
            }

            },
            redo:() => {
                if (util.isValidColorcode(propVal)) {
                    let color = this.resolveColor(propVal);
                    this.model.set(propName, color);
                }
                this.render();
                if (this.model.get('factoryKey') === "page_instance"
                || this.model.get('factoryKey') === "layout_page"
                || this.model.get('factoryKey') === "report_page") {
                pageSyncService.renderCurrentPageView();
            }
            }
        },textConstants.UNDO_PROP_CHANGE);


        if (util.isValidColorcode(propVal)) {
            let color = this.resolveColor(propVal);
            this.model.set(propName, color);
        }
        if (this.isThemeProperty(oldValue) ){
            themeService.deattachTheme(this);
        }

        // Call render if invalid color
        this.render();

        if (this.model.get('factoryKey') === "page_instance"
            || this.model.get('factoryKey') === "layout_page"
            || this.model.get('factoryKey') === "report_page") {
            pageSyncService.renderCurrentPageView();
        }

    }

    updateColorAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        let oldValue = this.model.get(propName);

        let color = this.resolveColor(propVal);
        // Update model
        if (util.isGroupContainer(this.model.get('factoryKey'))){
            util.updatePropertyRenderAndSendEvent(propName,color,this.model,this.render.bind(this),'GroupPropertyChange');

        }else{
            this.model.set(propName, color);
        }

        if (this.isThemeProperty(oldValue)){
            themeService.deattachTheme(this);
        }

        // Update text input
        $('#' + propName).val(color);

        if (this.model.get('factoryKey') === "page_instance"
            || this.model.get('factoryKey') === "layout_page"
            || this.model.get('factoryKey') === "report_page") {
                pageSyncService.renderCurrentPageView();
        }

        if(this.model.get('factoryKey') === 'control_captcha'){
            this.model.set('captchaImage', imageUtil.getCaptchaPresentationServerURLByView(this));
        }

        mobileSyncService.synchronize(this.model, {key: propName, val: propVal });

        undoService.add({
            undo: () =>{
                // Update model
                // PF-4777 Handling for radio and checkbox groups.
                if (util.isGroupContainer(this.model.get('factoryKey'))){
                    util.updatePropertyRenderAndSendEvent(propName,oldValue,this.model,this.render.bind(this),'GroupPropertyChange');
                }else{
                    this.model.set(propName, oldValue);
                }

                let oldColor = this.resolveColor(oldValue);
                // Update text input
                $('#' + propName).val(oldColor);
                if (this.model.get('factoryKey') === "page_instance"
                || this.model.get('factoryKey') === "layout_page"
                || this.model.get('factoryKey') === "report_page") {
                pageSyncService.renderCurrentPageView();
            }

            },
            redo:() => {
                // Update model
                // PF-4777 Handling for radio and checkbox groups.
                if (util.isGroupContainer(this.model.get('factoryKey'))){
                    util.updatePropertyRenderAndSendEvent(propName,color,this.model,this.render.bind(this),'GroupPropertyChange');

                }else{
                    this.model.set(propName, color);
                }

                let newColor = this.resolveColor(propVal);

                // Update text input
                $('#' + propName).val(newColor);
                if (this.model.get('factoryKey') === "page_instance"
                || this.model.get('factoryKey') === "layout_page"
                || this.model.get('factoryKey') === "report_page") {
                pageSyncService.renderCurrentPageView();
            }
            }
        },textConstants.UNDO_PROP_CHANGE)
    }
    
    updateTransparentBackground(ev){
        let name = ev.target.name;
        let value = ev.target.checked;
        let oldPropVal = this.model.get(name);
        if (util.isGroupContainer(this.model.get('factoryKey'))){
            util.updatePropertyRenderAndSendEvent(name,value,this.model,this.render.bind(this),'GroupPropertyChange')
        }else{
            this.model.set(name, value);
        }

        if ( this.isThemeProperty(this.model.get('backgroundColor')) ){
            themeService.deattachTheme(this);
        }

        if(util.isTrue(value)){
           $(`input[name=backgroundColor]`).prop('disabled',true);
        }else{
           $(`input[name=backgroundColor]`).prop('disabled',false);
        }

        undoService.add({
            undo: () =>{
                if (util.isGroupContainer(this.model.get('factoryKey'))){
                    util.updatePropertyRenderAndSendEvent(name,oldPropVal,this.model,this.render.bind(this),'GroupPropertyChange');
                }else{
                    this.model.set(name, oldPropVal);
                }

                if(util.isTrue(value)){
                    $(`input[name=backgroundColor]`).prop('disabled',true);
                }else{
                    $(`input[name=backgroundColor]`).prop('disabled',false);
                }
            },
            redo:() => {
                if (util.isGroupContainer(this.model.get('factoryKey'))){
                    util.updatePropertyRenderAndSendEvent(name,value,this.model,this.render.bind(this),'GroupPropertyChange');
                }else{
                    this.model.set(name, value);
                }

                if(util.isTrue(value)){
                    $(`input[name=backgroundColor]`).prop('disabled',true);
                }else{
                    $(`input[name=backgroundColor]`).prop('disabled',false);
                }
            }
        },textConstants.UNDO_PROP_CHANGE);
    }

    render() {
        super.render();

        this.usingBackgoundColor = false;
        let props = this.resolveThemeColors(this.model, ['backgroundColor','transparentBackground']);

        this.$el.html(this.template(props));

        if (constants.GROUP_KEYS.includes(this.model.get('factoryKey')) || this.model.get('factoryKey') === 'control_section')  {
            $('#backgroundTransparent').removeClass('hide');
 
            let transparentBackground = false;
            if(util.isTrue(props.transparentBackground) || props.transparentBackground === 'on'){
               transparentBackground = true;
            }
            $(`input[name='transparentBackground']`).prop('checked', transparentBackground);
            
            if(util.isTrue(transparentBackground)){
                $(`input[name=backgroundColor]`).prop('disabled',true);
            }else{
                $(`input[name=backgroundColor]`).prop('disabled',false);
            }
        }

        //.$('input[type=color]').spectrum(pickerCfg);

        this.delegateEvents();

        return this;
    }

}

export default StyleBackgroundColorView;
